// Centralized configuration for admin panel
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

// Debug logging for development
if (process.env.NODE_ENV === 'development') {
    console.log('🔧 Admin Panel Configuration:', {
        REACT_APP_API_URL: process.env.REACT_APP_API_URL,
        API_BASE_URL: API_BASE_URL,
        NODE_ENV: process.env.NODE_ENV
    });
    
    if (!process.env.REACT_APP_API_URL) {
        console.warn('⚠️ REACT_APP_API_URL not set, using localhost fallback');
    }
}

// Export the API URL
export const API_URL = API_BASE_URL;

// Helper functions for common endpoint patterns
export const getApiEndpoint = (path) => {
    // Remove leading slash if present to avoid double slashes
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    return `${API_URL}/${cleanPath}`;
};

export const getImageEndpoint = (productId) => getApiEndpoint(`images/products/${productId}`);
export const getImageDeleteEndpoint = (imageId) => getApiEndpoint(`images/${imageId}`);
export const getImagePrimaryEndpoint = (imageId) => getApiEndpoint(`images/${imageId}/primary`);
export const getImageOrderingEndpoint = (productId) => getApiEndpoint(`images/products/${productId}/ordering`);
export const getAuthEndpoint = (path) => getApiEndpoint(`auth/${path}`);
export const getBrandImageEndpoint = (brandId, imageType) => getApiEndpoint(`brands/${brandId}/${imageType}`);
export const getCategoryImageEndpoint = (categoryId) => getApiEndpoint(`categories/${categoryId}/image`);
export const getBlogImageEndpoint = (blogId) => getApiEndpoint(`blogs/${blogId}/cover-image`);

// Default export
export default {
    API_URL,
    getApiEndpoint,
    getImageEndpoint,
    getImageDeleteEndpoint,
    getImagePrimaryEndpoint,
    getImageOrderingEndpoint,
    getAuthEndpoint,
    getBrandImageEndpoint,
    getCategoryImageEndpoint,
    getBlogImageEndpoint
}; 